import VisualizadorDeArquivo from "@base/VisualizadorDeArquivo/VisualizadorDeArquivo"

export default VisualizadorDeArquivo;
